import {
  medigiLanding,
  medshortsLanding,
  outsourcingLanding,
  cgtLanding,
} from 'src/app/shared/models/landing';
import { defaultSupplierConfig } from 'src/environments/hydra/configs';
import { hydraSupplierConfigMap } from 'src/environments/hydra/config.map';

const supplierConfig =
  window.location.host in hydraSupplierConfigMap
    ? hydraSupplierConfigMap[window.location.host]
    : defaultSupplierConfig;

const baseURL = 'https://medigi-production-api.medigi.com';

export const environment = {
  production: false,
  env_name: 'prod',
  domain: 'www.medigi.com',
  url: 'https://www.medigi.com',
  api_url_v1: baseURL,
  api_url_v2: baseURL,
  singleton_service_url: 'https://default-production-api.medigi.com',
  medshorts_url: 'https://www.medshorts.com',
  flower_url: `${baseURL}:8081/misc/flower/dashboard`,
  health_url: `${baseURL}:8081/misc/health`,
  proxy_url: `${baseURL}/misc/proxy`,
  auth_url: `${baseURL}/auth`,
  auth_url_login: `${baseURL}/auth/login`,
  express222Form: 'asdf',
  gatag: undefined,
  clientDomains: {
    outsourcingDomian: 'www.503b.com',
    medigiDomain: 'www.medigi.com',
    medshortsDomain: 'www.medshorts.com',
    cgtDomain: 'cgt.medigi.com',
  },
  availableThemes: {
    'www.medigi.com': medigiLanding,
    'www.medshorts.com': medshortsLanding,
    'www.503b.com': outsourcingLanding,
    'cgt.medigi.com': cgtLanding,
  },
  catalogType: {
    'www.medigi.com': 'medigi',
    'www.medshorts.com': 'medshorts',
    'www.503b.com': '503b',
    'cgt.medigi.com': 'medigi',
  },
  hydraEnabled: false,
  customLogoutURL: undefined,
  auth0: {
    clientId: 'YqIMP5zpkB3zU23e31fRXbZ6vDVEUdP9',
    domain: 'medshorts.auth0.com',
    apiIdentifier: 'https://medshorts.auth0.com/api/v2/',
    appMetadata: 'http://medshorts.com/api/app_metadata',
    userMetadata: 'http://medshorts.com/api/user_metadata',
    clientId_disabled: 'YqIMP5zpkB3zU23e31fRXbZ6vDVEUdP9',
    supplierHostMap: {},
    domain_disabled: 'medshorts.auth0.com',
    redirectUri: `${window.location.origin}/callback`,
    redirect_uri: `${window.location.origin}/callback`,
  },
  sentry: {
    dsn: 'https://5e36bed6faf54ea9533855f85db421e0@o4506106420330496.ingest.sentry.io/4506107209580544',
  },
  posthog: {
    apiKey: 'phc_jbdhHfqjrBxucSE7TRC07TZ6aNJ1jplImvudvd9oWR9', // TODO: Make this a template variable if needed
    apiHost: 'https://us.i.posthog.com',
    enabled: false,
    autocapture: true,
    capture_pageview: true,
    session_recording: {
      enabled: true,
      maskAllInputs: true,
      maskTextSelector: '.sensitive, .phi, .pii',
    },
  },
  legisym_url: 'https://demo.dev.express222.com/prompt.php',
  supplierConfig: supplierConfig,
};
